import { AUTH_STATE } from '@/constants';
import { DeepPartial, UserEntity } from '@/types';
import { atomWithUniqueKey } from '@/utils';

export type AuthState = {
  user: DeepPartial<UserEntity>;
  loaded: boolean;
  loading: boolean;
};

export const useAuthState = atomWithUniqueKey<AuthState>({
  key: AUTH_STATE,
  default: {
    user: { typeDescription: null, id: null, company: { id: null, combo: { name: null, uuid: null } } },
    loaded: false,
    loading: false,
  },
});
